export async function sendMessage({ config, ee, sessionId, userState, page, message, chipsContext }) {
  const url = config.api_base + config.webhook_path

  const body = {
    session_id: sessionId,
    user_state: userState,
    ee_id: ee?.id || null,
    ee_token: ee?.token || null,
    email_scraped: ee?.email || null,
    page,
    message,
    locale: navigator.language || 'pt-PT',
    chips_context: chipsContext || [],
    tenant: config.tenant
  }

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'omit'
  })

  if (!res.ok) {
    throw new Error('webhook_error_' + res.status)
  }

  return res.json()
}

export async function fetchChipsConfig(url) {
  try {
    const res = await fetch(url, { method: 'GET' })
    if (!res.ok) return null
    return res.json()
  } catch {
    return null
  }
}

export function newSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return 'sess-' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}

export function loadSessionId(storageKey) {
  try {
    const existing = localStorage.getItem(storageKey)
    if (existing) return existing
    const fresh = newSessionId()
    localStorage.setItem(storageKey, fresh)
    return fresh
  } catch {
    return newSessionId()
  }
}
